import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { INDUSTRIES } from '../data/mock';
import FinalCTA from '../components/FinalCTA';

const CITIES = [
  'Bengaluru', 'Mumbai', 'Delhi NCR', 'Hyderabad',
  'Pune', 'Chennai', 'Kolkata', 'Ahmedabad',
  'Jaipur', 'Guwahati', 'Indore', 'Kochi',
];

const IndustriesHero = () => (
  <section className="relative pt-36 pb-16 overflow-hidden">
    <div className="absolute inset-0 bg-radial-glow pointer-events-none" />
    <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
    <div className="relative max-w-4xl mx-auto px-6 text-center">
      <p className="text-[#1AB6FF] font-semibold uppercase tracking-[0.2em] text-xs mb-4">Industries</p>
      <h1 className="font-display font-bold text-5xl md:text-6xl leading-[1.05]">
        Built for <span className="gradient-text">Bharat&rsquo;s</span> fastest growing sectors.
      </h1>
      <p className="mt-6 text-white/65 text-lg max-w-2xl mx-auto">
        We design operational systems for the realities of doing business in India&mdash;multi-city teams, multi-lingual customers, and high-velocity growth.
      </p>
    </div>
  </section>
);

const IndustryCard = ({ industry }) => (
  <div className="card-tech rounded-2xl overflow-hidden group">
    <div className="relative aspect-[4/3] overflow-hidden">
      <img
        src={industry.image}
        alt={industry.title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#04070d] via-[#04070d]/20 to-transparent" />
    </div>
    <div className="p-5">
      <h3 className="font-display font-semibold text-xl text-white">{industry.title}</h3>
      <p className="mt-1 text-white/55 text-sm">{industry.tagline}</p>
      <Link to="/contact" className="mt-4 inline-flex items-center gap-1.5 text-[#1AB6FF] text-sm font-medium hover:gap-2.5 transition-all">
        Learn more <ArrowRight size={14} />
      </Link>
    </div>
  </div>
);

const IndustriesGrid = () => (
  <section className="py-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {INDUSTRIES.map((ind) => (
        <IndustryCard key={ind.title} industry={ind} />
      ))}
    </div>
  </section>
);

const CityPill = ({ name }) => (
  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#1AB6FF]/25 bg-[#0a1018] text-sm text-white/80">
    <MapPin size={14} className="text-[#1AB6FF]" /> {name}
  </span>
);

const CitiesSection = () => (
  <section className="py-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <h2 className="font-display font-bold text-3xl md:text-4xl text-center">
        Serving teams across <span className="gradient-text">12+ Indian cities.</span>
      </h2>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        {CITIES.map((c) => (
          <CityPill key={c} name={c} />
        ))}
      </div>
    </div>
  </section>
);

const IndustriesPage = () => (
  <div>
    <IndustriesHero />
    <IndustriesGrid />
    <CitiesSection />
    <FinalCTA />
  </div>
);

export default IndustriesPage;
